module.exports = __webpack_public_path__ + "static/media/LP9.598387c8.svg";